document.addEventListener('alpine:init', () => {
  Alpine.data('HTMLVideo', () => ({
    muted: true,
    playing: false,
    init() {
      this.muted = this.$refs.video.muted;
      this.playing = !this.$refs.video.paused;

      this.$refs.video.addEventListener('play', () => {
        this.playing = true;
        this.$root.dispatchEvent(
          new CustomEvent('playing', {
            bubbles: true,
          })
        );
      });

      this.$refs.video.addEventListener('pause', () => {
        this.playing = false;
        this.$root.dispatchEvent(
          new CustomEvent('paused', {
            bubbles: true,
          })
        );
      });

      this.$refs.video.addEventListener('volumechange', () => {
        this.muted = this.$refs.video.muted;
      });

      // Safari won't autoplay inserted videos
      if (this.$refs.video.autoplay) {
        this.$nextTick(() => {
          this.$refs.video.play();
        });
      }
    },
    play() {
      this.$refs.video.play();
    },
    pause() {
      this.$refs.video.pause();
    },
    togglePlay() {
      if (this.$refs.video.paused) {
        this.$refs.video.play();
      } else {
        this.$refs.video.pause();
      }
    },
    toggleMute() {
      this.$refs.video.muted = !this.$refs.video.muted;
    },
  }));
});
